import { APIBase } from 'config/axiosBase';
import { swalNotice500 } from '../helper/notice.helper';

import * as url from 'config/url_api';

const apiBase = new APIBase();

//Auth
export const authSignIn = (data) => apiBase.post(url.API_AUTH_LOGIN, data);

//User
export const getUsers = (data) => apiBase.get(url.API_GET_ALL_USERS);
export const createUsers = (data) => apiBase.post(url.API_GET_ALL_USERS, data);
export const updateUsers = (id, data) => apiBase.put(`${url.API_GET_ALL_USERS}/${id}`, data);

export const getRoles = () => apiBase.get(url.API_GET_ALL_ROLE);
export const getByToken = () => apiBase.get(url.API_USERS_TOKEN);

//Match
export const createMatch = (data) => apiBase.post(url.API_MATCH, data);
export const getWcMatches = () => apiBase.get(`${url.API_MATCH_WC_MATCHES}?site=78win`);
export const getUpcomingSchedule = () => apiBase.get(url.API_MATCH_UPCOMING_SCHEDULE);
export const getPagingMatch = (data) => apiBase.get(`${url.API_MATCH}${data && `?${data}`}`, data);
export const deleteMatch = (id) => apiBase.delete(`${url.API_MATCH}${id && `/${id}`}`);
export const updateMatch = (id, data) => apiBase.post(`${url.API_MATCH}/${id}`, data);

export const updateMatchResult = (data) => apiBase.post(`${url.API_MATCH_RESULT}`, data);

//Settings
export const createOrUpdateSetting = (data) => apiBase.post(url.API_SETTINGS, data);
export const getAllSetting = (data) => apiBase.get(`${url.API_SETTINGS}${data && `?${data}`}`);
export const getUpdateSettingRank = () => apiBase.get(url.API_SETTINGS_RANK);
export const getUpdateSettingPrizeStructure = () => apiBase.get(url.API_SETTINGS_PRIZE_STRUCTURE);

//Banner
export const createBanner = (data) => apiBase.post(url.API_BANNER, data);
export const getAllBanner = (data) => apiBase.get(`${url.API_BANNER}${data && `?${data}`}`);
export const updateBanner = (query, data) =>
  apiBase.post(`${url.API_BANNER}${query && `?${query}`}`, data);

//Predictions
export const getPagingPredictons = (data) =>
  apiBase.get(`${url.API_PREDICTIONS}${data && `?${data}`}`, data);

export const updatePredictonsResult = (id, data) =>
  apiBase.post(`${url.API_PREDICTIONS}/${id}`, data);

//Upload
export const uploadImage = (data) => apiBase.postFile(url.API_UPLOAD_IMAGE, data);

// setup cài đặt khuyến mãi tặng điểm
export const getOnePromo = async (site, promo_id) => {
  let requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };
  let urlFetch = '/coupons/get-one?site=' + site + '&promo_id=' + promo_id + '&name=BONGDA';
  return fetch(process.env.REACT_APP_STORAGE_URL + urlFetch, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log('error', error);
      swalNotice500();
    });
};
export const updatePromo = async (id, site, bodyRaw) => {
  let myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  myHeaders.append('Content-Type', 'application/json');
  let raw = JSON.stringify(bodyRaw);
  let timestamps = new Date().getTime();
  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  let url = '/coupons?id=' + id + '&site=' + site + '&timestamps=' + timestamps;

  return fetch(process.env.REACT_APP_STORAGE_URL + url, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log('error', error);
      swalNotice500();
    });
};

export const create_whitelist = async (ip, comment) => {
  let myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  myHeaders.append('Content-Type', 'application/json');

  let site = localStorage.getItem('site');
  let raw = JSON.stringify({
    ip: ip,
    comment: comment
  });

  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  console.log(1);
  return fetch(process.env.REACT_APP_STORAGE_URL + '/auth/whitelist', requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log('error', error);
      swalNotice500();
    });
};

export const get_whitelist = async () => {
  let myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  myHeaders.append('Content-Type', 'application/json');

  let site = localStorage.getItem('site');

  let requestOptions = {
    method: 'GET',
    redirect: 'follow',
    headers: myHeaders
  };

  console.log(2);
  console.log(site);
  return fetch(process.env.REACT_APP_STORAGE_URL + '/auth/whitelist', requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log('error', error);
      swalNotice500();
    });
};

export const delete_whitelist = async (ip) => {
  let myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  myHeaders.append('Content-Type', 'application/json');

  let site = localStorage.getItem('site');
  let raw = JSON.stringify({
    ip: ip
  });

  let requestOptions = {
    method: 'DELETE',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  console.log(3);
  return fetch(process.env.REACT_APP_STORAGE_URL + '/auth/whitelist', requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log('error', error);
      swalNotice500();
    });
};

export const update_whitelist = async (ip, rawBody) => {
  let myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  myHeaders.append('Content-Type', 'application/json');
  let site = localStorage.getItem('site');
  let raw = JSON.stringify(rawBody);
  let requestOptions = {
    method: 'PATCH',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  console.log(4);
  fetch(process.env.REACT_APP_STORAGE_URL + '/auth/whitelist?ip=' + ip, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.log('error', error);
      swalNotice500();
    });
};
